import { c as _c } from "react/compiler-runtime";
import React from "react";
import PrimaryButton from "../utils/button/PrimaryButton";
interface CreateDropSubmitProps {
  readonly submitting: boolean;
  readonly canSubmit: boolean;
  readonly disabledTooltip?: string | null | undefined;
  readonly isDropMode: boolean;
  readonly onDrop: () => void;
}
export const CreateDropSubmit: React.FC<CreateDropSubmitProps> = t0 => {
  const $ = _c(13);
  const {
    submitting,
    canSubmit,
    disabledTooltip: t1,
    isDropMode,
    onDrop
  } = t0;
  const disabledTooltip = t1 === undefined ? null : t1;
  const submitLabel = isDropMode ? "Drop" : "Post";
  const title = !canSubmit && disabledTooltip ? disabledTooltip : undefined;
  const t2 = !canSubmit;
  const t3 = submitting ? `${submitLabel} in progress` : submitLabel;
  let t4;
  if ($[0] !== submitLabel) {
    t4 = <span className="tw-hidden lg:tw-inline">{submitLabel}</span>;
    $[0] = submitLabel;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tw-size-5 lg:tw-hidden"><path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" /></svg>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== onDrop || $[4] !== submitting || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== title) {
    t6 = <PrimaryButton onClicked={onDrop} loading={submitting} disabled={t2} title={title} padding="tw-w-10 tw-px-2.5 tw-py-3 lg:tw-w-[3.875rem] lg:tw-px-3.5" ariaLabel={t3} hideChildrenWhenLoading={true}>{t4}{t5}</PrimaryButton>;
    $[3] = onDrop;
    $[4] = submitting;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const button = t6;
  let t7;
  if ($[10] !== button || $[11] !== title) {
    t7 = title ? <span className="tw-inline-flex" title={title}>{button}</span> : button;
    $[10] = button;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};